module.exports = __webpack_public_path__ + "static/media/woocommerce-logo.2a0e4536.svg";